import React from 'react';

export default ({id, children}) => {
    return (
        <div id={id} className="flex-col justify-center flex mx-4 min-h-screen">
            {children}
        </div>
    );
};
